module.exports = __webpack_public_path__ + "img/search-hero-overflow-mitsu.bc3632dd.png";